import React from 'react'
import DialogView from '../../../Dialogos/DialogView'
import ReingresarCPADialogView from './ReingresarCPADialogView'

const ReingresarCPADialog = (props) => {
  const { confirmCallback, cancelCallback, cpa, presunta } = props
  return (
    <DialogView
      confirmCallback={confirmCallback}
      cancelCallback={cancelCallback}
      title='Reingreso de Carta de Porte Rechazada'
      content={
        <ReingresarCPADialogView
          cpa={cpa}
          presunta={presunta}
        />
      }
    />
  )
}

export default ReingresarCPADialog
